import ETIQUETAS from '@/graphql/querys/administracion/catalogos/etiquetas/etiquetas.gql';
import AGREGAR_ETIQUETAS from '@/graphql/mutations/administracion/etiquetas/agregarEtiquetas.gql';
import CONTRATO from '@/graphql/querys/administracion/contratos/contrato.gql';

export default {
  apollo: {
    etiquetas: {
      query: ETIQUETAS,
      variables() {
        return {
          filtros: {
            modulo: this.modulo,
          },
        };
      },
    },
  },
  methods: {
    async mixGuardar() {
      this.enviandoFormulario = true;
      this.mixEsCargando();
      // Enviar la informacion
      await this.$apollo
        .mutate({
          mutation: AGREGAR_ETIQUETAS,
          variables: {
            idReferencia: this.idReferencia,
            etiquetas: this.getIdsEtiquetasSeleccionadas,
          },
          update: (store, { data: { agregarEtiquetas } }) => {
            const query = {
              query: CONTRATO,
              variables: {
                id: this.idReferencia,
              },
            };

            const { contrato } = store.readQuery(query);
            contrato.etiquetas.push(...agregarEtiquetas);

            store.writeQuery({
              ...query,
              data: {
                contrato,
              },
            });
          },
        }).then(() => {
          this.mixMensajeSuccess();
          this.cerrar();
        }).catch((err) => {
          this.mixMensajeError(err);
        });

      this.enviandoFormulario = false;
      this.mixEsCargando();
    },
  },
  computed: {
    mixGetEtiquetas() {
      if (!this.etiquetas) return [];
      return this.etiquetas
        .filter(({ id }) => this.etiquetasAgregadas.includes(id) === false);
    },
  },
};
